/*
	

	

	
|--------------------------------------------------------------------------
| Template Slots and Maps: DFP
|--------------------------------------------------------------------------
*/
/**
 * @namespace --  
 */




var dfpAdUnitMap = {
	"template": {
		"homepage": {
			"adunit": "homepage"
		},
		"sectionStandard": {
			"adunit": "news"
		},
		"article": {
			"adunit": "news"
		}
	}
}

var dfpMaps = {
	"map": {
		"baseLeaderBillboard": {
			"view1": {
					"viewport": [970,200],
					"ad_sizes": [[728,90],[970,90],[970,250]]
			},
			"view2": {
					"viewport": [0,0],
					"ad_sizes": [[300,250],[320,50]]
			}
		},
		"baseLeaderBillboardHomepage": {
			"view1": {
					"viewport": [970,200],
					"ad_sizes": [[728,90],[970,90],[970,250]]
			},
			"view2": {
					"viewport": [768,200],
					"ad_sizes": [[300,250],[320,50]]
			},
			"view3": {
					"viewport": [0,0],
					"ad_sizes": []
			}
		},
		"baseLeaderBillboardMobile": {
			"view1": {
					"viewport": [768,200],
					"ad_sizes": []
			},
			"view2": {
					"viewport": [0,0],
					"ad_sizes": [[300,250],[320,50]]
			}
		},
		"baseLeaderboard": {
			"view1": {
					"viewport": [970,200],
					"ad_sizes": [[728,90],[970,90]]
			},
			"view2": {
					"viewport": [0,0],
					"ad_sizes": [320,50]
				}
		},
		"baseLeaderboardNoSuper": {
			"view1": {
					"viewport": [970,200],
					"ad_sizes": [728,90]
			},
			"view2": {
					"viewport": [0,0],
					"ad_sizes": [320,50]
				}
		},
		"baseMedRecDesktop": {
			"view1": {
					"viewport": [768,200],
					"ad_sizes": [300,250]
			},
			"view2": {
					"viewport": [0,0],
					"ad_sizes": []
				}
		},
		"baseMedRecMobile": {
			"view1": {
					"viewport": [768,200],
					"ad_sizes": []
			},
			"view2": {
					"viewport": [0,0],
					"ad_sizes": [300,250]
				}
		},
		"baseMedRec768": {
			"view1": {
					"viewport": [768,200],
					"ad_sizes": [300,250]
			},
			"view2": {
					"viewport": [0,0],
					"ad_sizes": []
				}
		},
		"promoDesktop": {
			"view1": {
					"viewport": [992,200],
					"ad_sizes": [320,250]
			},
			"view2": {
					"viewport": [0,0],
					"ad_sizes": []
				}
		}
	}
}

var homepageSlots ={
	"base": {
		"type": "homepage",
		"keyvalues": {
			"pgtype": "homepage",
			"platform": "web",
			"user-type": "~Unknown",
			"referrer-type": "",
			"keyword": "~TaxonomyKeywords",
			"kuid": "~Krux.user",
			"ksg": "~Krux.segments"
		},
		
		"slots": {
			"standard": {
				"baseMedRecDesktop": {
				"id": "0",
					"dimensions": [{
						"id": 1,
						"size": {
							"w": 300,
							"h": 250
						}
					}],
					"keyvalues": {
						"sov": "base ROS",
						"ad-type": "Standard",
						"slot":	"Base Med Rec",
						"order":	"1"
						
					}
				},
				"baseMedRecMobile": {
				"id": "1",
					"dimensions": [{
						"id": 1,
						"size": {
							"w": 300,
							"h": 250
						}
					}],
					"keyvalues": {
						"sov": "base ROS",
						"ad-type": "Standard",
						"slot":	"Base Med Rec",
						"order":	"1"
					}
				},
				"baseLeaderBillboardDesktop": {
					"id": "2",
					"dimensions": [{
						"id": 1,
						"size": {
							"w": 970,
							"h": 250
						}
					}, {
						"id": 2,
						"size": {
							"w": 970,
							"h": 90
						}
					}, {
						"id": 3,
						"size": {
							"w": 728,
							"h": 90
						}
					}],
					"keyvalues": {
						"sov": "base ROS",
						"ad-type": "Standard",
						"slot":	"Base Leaderboard",
						"order":	"2"
					}
				},
				"baseLeaderBillboardMobile": {
					"id": "3",
					"dimensions": [{
						"id": 1,
						"size": {
							"w": 320,
							"h": 50
						}
					}, {
						"id": 2,
						"size": {
							"w": 300,
							"h": 250
						}
					}],
					"keyvalues": {
						"sov": "base ROS",
						"ad-type": "Standard",
						"slot":	"Base Leaderboard",
						"order":	"2"
					}
				}
			},
			"rich media": {
				"slidingBillboard": {
					"id": "4",
				    "dimensions": [{
						"id": 1,
						"size": {
							"w": 1,
							"h": 1
						}
					}],
					"keyvalues": {
						"outofpage": "sbillboard",
						"sov": "base ROS",
						"ad-type": "Rich Media",
						"slot":	"Sliding Billboard",
						"creative-format":	"Sliding Billboard,Sliding Billboard Wallpaper,Edge,Outstream Video"
					}
				},

				"wallpaper": {
					"id": "5",
					"dimensions": [{
						"id": 1,
						"size": {
							"w": 1,
							"h": 1
						}
					}],
					"keyvalues": {
						"outofpage": "wallpaper",
						"sov": "base ROS",
						"ad-type": "Rich Media",
						"slot":	"Wallpaper"
					}
				}
			}
		}
	}
}

var sectionStandardSlots = {
	"base": {
		"type": "section",
		"keyvalues": {
			"pgtype": "section",
			"platform": "web",
			"user-type": "~Unknown",
			"referrer-type": "",
			"keyword": "~TaxonomyKeywords",
			"kuid": "~Krux.user",
			"ksg": "~Krux.segments",
			"pageID": "~pageID"
		},
		
		"slots": {
			"standard": {
				"baseMedRec": {
				"id": "0",
					"dimensions": [{
						"id": 1,
						"size": {
							"w": 300,
							"h": 250
						}
					}],
					"keyvalues": {
						"sov": "base ROS",
						"ad-type": "Standard",
						"slot":	"Base Med Rec",
						"order":	"1"
					}
				},
				"baseLeaderBillboard": {
					"id": "1",
					"dimensions": [{
						"id": 1,
						"size": {
							"w": 970,
							"h": 250
						}
					}, {
						"id": 2,
						"size": {
							"w": 970,
							"h": 90
						}
					}, {
						"id": 3,
						"size": {
							"w": 728,
							"h": 90
						}
					}],
					"keyvalues": {
						"sov": "base ROS",
						"ad-type": "Standard",
						"slot":	"Base Leaderboard",
						"order":	"2"
					}
				}
			},
			"rich media": {
				"slidingBillboard": {
					"id": "2",
				    "dimensions": [{
						"id": 1,
						"size": {
							"w": 1,
							"h": 1
						}
					}],
					"keyvalues": {
						"outofpage": "sbillboard",
						"sov": "base ROS",
						"ad-type": "Rich Media",
						"slot":	"Sliding Billboard",
						"creative-format":	"Sliding Billboard,Sliding Billboard Wallpaper,Edge,Outstream Video"
					}
				},

				"wallpaper": {
					"id": "3",
					"dimensions": [{
						"id": 1,
						"size": {
							"w": 1,
							"h": 1
						}
					}],
					"keyvalues": {
						"outofpage": "wallpaper",
						"sov": "base ROS",
						"ad-type": "Rich Media",
						"slot":	"Wallpaper"
					}
				}
			}
		}
	}
}

var articleSlots ={
	"base": {
		"type": "article",
		"keyvalues": {
			"pgtype": "article",
			"platform": "web",
			"user-type": "~Unknown",
			"referrer-type": "",
			"keyword": "~TaxonomyKeywords",
			"kuid": "~Krux.user",
			"ksg": "~Krux.segments",
			"url": "~dfp_url"
		},
		
		"slots": {
			"standard": {
				"baseLeaderboard": {
					"id": "0",
					"dimensions": [{
						"id": 1,
						"size": {
							"w": 970,
							"h": 90
						}
					}, {
						"id": 2,
						"size": {
							"w": 728,
							"h": 90
						}
					}],
					"keyvalues": {
						"sov": "base ROS",
						"ad-type": "Standard",
						"slot":	"Base Leaderboard",
						"order":	"1"
					}
				},
				"baseMedRec": {
				"id": "1",
					"dimensions": [{
						"id": 1,
						"size": {
							"w": 300,
							"h": 250
						}
					}],
					"keyvalues": {
						"sov": "base ROS",
						"ad-type": "Standard",
						"slot":	"Base Med Rec",
						"order":	"2"
					}
				}
			},
			"rich media": {
				"interstitial": {
					"id": "2",
					"dimensions": [{
						"id": 1,
						"size": {
							"w": 1,
							"h": 1
						}
					}],
					"keyvalues": {
						"outofpage": "interstitial",
						"sov": "base ROS",
						"ad-type": "Rich Media",
						"slot":	"Interstitial",
						"creative-format":	"Interstitial,Outstream Video"
					}
				}
			}
		}
	}
}

var verticalSlots = {
	"base": {
		"type": "section",
		"keyvalues": {
			"pgtype": "section",
			"platform": "web",
			"user-type": "~Unknown",
			"referrer-type": "",
			"keyword": "~TaxonomyKeywords",
			"kuid": "~Krux.user",
			"ksg": "~Krux.segments"
		},
		
		"slots": {
			"standard": {
				"baseLeaderboard": {
					"id": "0",
					"dimensions": [{
						"id": 1,
						"size": {
							"w": 970,
							"h": 90
						}
					}, {
						"id": 2,
						"size": {
							"w": 728,
							"h": 90
						}
					}],
					"keyvalues": {
						"sov": "base ROS",
						"ad-type": "Standard",
						"slot":	"Base Leaderboard",
						"order":	"1"
					}
				},
				"baseMedRec": {
				"id": "1",
					"dimensions": [{
						"id": 1,
						"size": {
							"w": 300,
							"h": 250
						}
					}],
					"keyvalues": {
						"sov": "base ROS",
						"ad-type": "Standard",
						"slot":	"Base Med Rec",
						"order":	"2"
					}
				}
			},
		}
	}
}

var sectionPhotoSlots ={
	"base": {
		"type": "photogallery",
		"keyvalues": {
			"pgtype": "photogallery",
			"platform": "web",
			"user-type": "~Unknown",
			"referrer-type": "",
			"keyword": "~TaxonomyKeywords",
			"kuid": "~Krux.user",
			"ksg": "~Krux.segments"
		},
		
		"slots": {
			"standard": {
				"baseLeaderboard": {
					"id": "0",
					"dimensions": [{
						"id": 1,
						"size": {
							"w": 970,
							"h": 90
						}
					}, {
						"id": 2,
						"size": {
							"w": 728,
							"h": 90
						}
					}],
					"keyvalues": {
						"sov": "base ROS",
						"ad-type": "Standard",
						"slot":	"Base Leaderboard",
						"order":	"1"
					}
				}
			},
		}
	}
}

var sectionVideoSlots ={
	"base": {
		"type": "video",
		"keyvalues": {
			"pgtype": "video",
			"platform": "web",
			"user-type": "~Unknown",
			"referrer-type": "",
			"keyword": "~TaxonomyKeywords",
			"kuid": "~Krux.user",
			"ksg": "~Krux.segments"
		},
		
		"slots": {
			"standard": {
				"baseLeaderboard": {
					"id": "0",
					"dimensions": [{
						"id": 1,
						"size": {
							"w": 970,
							"h": 90
						}
					}, {
						"id": 2,
						"size": {
							"w": 728,
							"h": 90
						}
					}],
					"keyvalues": {
						"sov": "base ROS",
						"ad-type": "Standard",
						"slot":	"Base Leaderboard",
						"order":	"1"
					}
				}
			},
		}
	}
}

var wrapperSlots = {
	"base": {
		"type": "section",
		"keyvalues": {
			"pgtype": "wrapper",
			"platform": "web",
			"user-type": "~Unknown",
			"referrer-type": "",
			"keyword": "~TaxonomyKeywords",
			"kuid": "~Krux.user",
			"ksg": "~Krux.segments"
		},
		
		"slots": {
			"standard": {
				"baseLeaderboard": {
					"id": "0",
					"dimensions": [{
						"id": 1,
						"size": {
							"w": 970,
							"h": 90
						}
					}, {
						"id": 2,
						"size": {
							"w": 728,
							"h": 90
						}
					}],
					"keyvalues": {
						"sov": "base ROS",
						"ad-type": "Standard",
						"slot":	"Base Leaderboard",
						"order":	"1"
					}
				},
				"baseMedRec": {
				"id": "1",
					"dimensions": [{
						"id": 1,
						"size": {
							"w": 300,
							"h": 250
						}
					}],
					"keyvalues": {
						"sov": "base ROS",
						"ad-type": "Standard",
						"slot":	"Base Med Rec",
						"order":	"2"
					}
				}
			},
			"rich media": {
				"wallpaper": {
					"id": "2",
					"dimensions": [{
						"id": 1,
						"size": {
							"w": 1,
							"h": 1
						}
					}],
					"keyvalues": {
						"outofpage": "wallpaper",
						"sov": "base ROS",
						"ad-type": "Rich Media",
						"slot":	"Wallpaper"
					}
				}
			}
		}
	}
}

var searchSlots = {
	"base": {
		"type": "SiteSearch",
		"keyvalues": {
			"pgtype": "SiteSearch",
			"platform": "web",
			"user-type": "~Unknown",
			"referrer-type": "",
			"keyword": "~TaxonomyKeywords",
			"kuid": "~Krux.user",
			"ksg": "~Krux.segments"
		},
		
		"slots": {
			"standard": {
				"baseMedRec": {
				"id": "0",
					"dimensions": [{
						"id": 1,
						"size": {
							"w": 300,
							"h": 250
						}
					}],
					"keyvalues": {
						"sov": "base ROS",
						"ad-type": "Standard",
						"slot":	"Base Med Rec",
						"order":	"1"
					}
				},
				"baseLeaderboard": {
					"id": "1",
					"dimensions": [{
						"id": 1,
						"size": {
							"w": 970,
							"h": 90
						}
					}, {
						"id": 2,
						"size": {
							"w": 728,
							"h": 90
						}
					}],
					"keyvalues": {
						"sov": "base ROS",
						"ad-type": "Standard",
						"slot":	"Base Leaderboard",
						"order":	"2"
					}
				}
			}
		}
	}
}

var legacyHeaderSlots = {
	"base": {
		"type": "section",
		"keyvalues": {
			"pgtype": "wrapper",
			"platform": "web",
			"user-type": "~Unknown",
			"keyword": "obituaries",
			"referrer-type": "",
			"kuid": "~Krux.user"
		},
		
		"slots": {
			"standard": {
				"baseLeaderboard": {
					"id": "0",
					"dimensions": [{
						"id": 1,
						"size": {
							"w": 970,
							"h": 90
						}
					}, {
						"id": 2,
						"size": {
							"w": 728,
							"h": 90
						}
					}],
					"keyvalues": {
						"sov": "base ROS",
						"ad-type": "Standard",
						"slot":	"BaseLeaderboard",
						"order":	"1"
					}
				}
			}
		}
	}
}

var weatherSlots = {
	"base": {
		"type": "section",
		"keyvalues": {
			"pgtype": "section",
			"platform": "web",
			"user-type": "~Unknown",
			"keyword": "weather",
			"referrer-type": "",
			"kuid": "~Krux.user"
		},
		
		"slots": {
			"standard": {
				"baseLeaderboard": {
					"id": "1",
					"dimensions": [{
						"id": 1,
						"size": {
							"w": 970,
							"h": 90
						}
					}, {
						"id": 2,
						"size": {
							"w": 728,
							"h": 90
						}
					}],
					"keyvalues": {
						"sov": "base ROS",
						"ad-type": "Standard",
						"slot":	"Base Leaderboard",
						"order":	"1"
					}
				}
			}
		}
	}
}

var headerOnlySlots = {
	"base": {
		"type": "section",
		"keyvalues": {
			"pgtype": "wrapper",
			"platform": "web",
			"user-type": "~Unknown",
			"referrer-type": "",
			"keyword": "~TaxonomyKeywords",
			"kuid": "~Krux.user"
		},
		
		"slots": {
			"standard": {
				"baseLeaderboard": {
					"id": "0",
					"dimensions": [{
						"id": 1,
						"size": {
							"w": 728,
							"h": 90
						}
					}],
					"keyvalues": {
						"sov": "base ROS",
						"ad-type": "Standard",
						"slot":	"BaseLeaderboard",
						"order":	"1"
					}
				}
			}
		}
	}
}

var footerOnlySlots = {
	"base": {
		"type": "section",
		"keyvalues": {
			"pgtype": "wrapper",
			"platform": "web",
			"user-type": "~Unknown",
			"referrer-type": "",
			"kuid": "~Krux.user"
		},
		
		"slots": {
		}
	}
}

var baseLeaderSlots = {
	"base": {
		"type": "section",
		"keyvalues": {
			"pgtype": "wrapper",
			"platform": "web",
			"user-type": "~Unknown",
			"referrer-type": "",
			"kuid": "~Krux.user"
		},
		
		"slots": {
			"standard": {
				"baseLeaderboard": {
					"id": "0",
					"dimensions": [{
						"id": 1,
						"size": {
							"w": 728,
							"h": 90
						}
					}],
					"keyvalues": {
						"sov": "base ROS",
						"ad-type": "Standard",
						"slot":	"Base Leaderboard",
						"order":	"1"
					}
				}
			}
		}
	}
}

var baseMedRecSlots = {
	"base": {
		"type": "section",
		"keyvalues": {
			"pgtype": "wrapper",
			"platform": "web",
			"user-type": "~Unknown",
			"referrer-type": "",
			"kuid": "~Krux.user"
		},
		
		"slots": {
			"standard": {
				"baseMedRec": {
					"id": "0",
					"dimensions": [{
						"id": 1,
						"size": {
							"w": 300,
							"h": 250
						}
					}],
					"keyvalues": {
						"sov": "base ROS",
						"ad-type": "Standard",
						"slot":	"Base Med Rec",
						"order":	"1"
					}
				}
			}
		}
	}
}

var viewPlusLeaderSlots = {
	"base": {
		"type": "section",
		"keyvalues": {
			"pgtype": "wrapper",
			"platform": "web",
			"user-type": "~Unknown",
			"referrer-type": "",
			"kuid": "~Krux.user"
		},
		
		"slots": {
			"standard": {
				"viewPlusLeaderboard": {
					"id": "0",
					"dimensions": [{
						"id": 1,
						"size": {
							"w": 728,
							"h": 90
						}
					}],
					"keyvalues": {
						"sov": "Standalone",
						"ad-type": "Standard",
						"slot":	"View Plus Leaderboard",
						"order":	"1"
					}
				}
			}
		}
	}
}

var viewPlusMedRecSlots = {
	"base": {
		"type": "section",
		"keyvalues": {
			"pgtype": "wrapper",
			"platform": "web",
			"user-type": "~Unknown",
			"referrer-type": "",
			"kuid": "~Krux.user"
		},
		
		"slots": {
			"standard": {
				"viewPlusMedRec": {
					"id": "0",
					"dimensions": [{
						"id": 1,
						"size": {
							"w": 300,
							"h": 250
						}
					}],
					"keyvalues": {
						"sov": "Standalone",
						"ad-type": "Standard",
						"slot":	"View Plus Med Rec",
						"order":	"1"
					}
				}
			}
		}
	}
}



var nativeSlots = {
	"base": {
		"type": "section",
		"keyvalues": {
			"pgtype": "CustomContent",
			"platform": "web",
			"user-type": "~Unknown",
			"referrer-type": "",
			"kuid": "~Krux.user",
			"ad-type": "Native Banner"
		},
		
		"slots": {
		}
	}
}


var tmplDefinitionsJSON = {
	"template": {
		"homepage": {
			"slotFeed": homepageSlots
		},
		"sectionStandard": {
			"slotFeed": sectionStandardSlots
		},
		"vertical": {
			"slotFeed": verticalSlots
		},
		"article": {
			"slotFeed": articleSlots
		},
		"sectionVideo": {
			"slotFeed": sectionVideoSlots
		},
		"sectionPhoto": {
			"slotFeed": sectionPhotoSlots
		},
		"wrapper": {
			"slotFeed": wrapperSlots
		},
		"search": {
			"slotFeed": searchSlots
		},
		"legacyHeader": {
			"slotFeed": legacyHeaderSlots
		},
		"headerOnly": {
			"slotFeed": headerOnlySlots
		},
		"footerOnly": {
			"slotFeed": footerOnlySlots
		},
		"weather": {
			"slotFeed": weatherSlots
		},
		"baseLeader": {
			"slotFeed": baseLeaderSlots
		},
		"baseMedRec": {
			"slotFeed": baseMedRecSlots
		},
		"viewPlusLeader": {
			"slotFeed": viewPlusLeaderSlots
		},
		"viewPlusMedRec": {
			"slotFeed": viewPlusMedRecSlots
		},
		"native": {
			"slotFeed": nativeSlots
		}
		
	}
}

